import { getRouterDatasetName } from '@wix/wix-data-client-common'
import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import type { AppApi } from '@wix/wix-data-client-common'

type FieldMap = Record<string, string>

export const updateDatasetAndBindings = async ({
  appApi,
  controllerRef,
  newCollectionId,
  newCollectionDisplayName,
  fieldMap,
}: {
  appApi: AppApi
  controllerRef: ComponentRef
  newCollectionId: string
  newCollectionDisplayName: string
  fieldMap: FieldMap
}) => {
  await appApi.setDatasetDisplayName(
    controllerRef,
    getRouterDatasetName(newCollectionDisplayName),
    true,
  )

  await appApi.rebindComponentsToAnotherCollection({
    fieldMap,
    controllerRef,
    newCollectionId,
  })
}
